import { render, staticRenderFns } from "./BillErrorAlert.vue?vue&type=template&id=013037c8&scoped=true"
import script from "./BillErrorAlert.vue?vue&type=script&lang=js"
export * from "./BillErrorAlert.vue?vue&type=script&lang=js"
import style0 from "./BillErrorAlert.vue?vue&type=style&index=0&id=013037c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013037c8",
  null
  
)

export default component.exports